import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isSameOrAfter);
dayjs.extend(timezone);
dayjs.extend(utc);

export { dayjs as djs };

export const DATE_SHORT_FORMAT = 'MMM D, YYYY';
export const DATE_TIME_FORMAT = `${DATE_SHORT_FORMAT} · h:mm A`;
